<template>
  <div class="material-card">
    <div class="card-header">
      <h4 class="card-title">{{ title }}</h4>
    </div>
    <div class="card-body">
      <div class="card-row" v-for="(row, idx) in rows" :key="idx">
        <div class="row-label">{{ row.label }}</div>
        <div class="row-value">
          <slot :name="row.key" :row="row">
            {{ row.value || '-' }}
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  rows: {
    type: Array,
    required: true
  }
});
</script>

<style scoped lang="scss">
.material-card {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #eaeaea;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  margin-bottom: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  }

  .card-header {
    background-color: #f9f9f9;
    padding: 16px 20px;
    border-bottom: 1px solid #f2f2f2;

    .card-title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      margin: 0;
      line-height: 1.4;
      word-break: break-all;
    }
  }

  .card-body {
    padding: 8px 20px;
  }

  .card-row {
    display: flex;
    padding: 12px 0;
    align-items: flex-start;
    border-bottom: 1px solid #f2f2f2;

    &:last-child {
      border-bottom: none;
    }

    .row-label {
      width: 140px;
      flex-shrink: 0;
      font-size: 15px;
      color: #757575;
      font-weight: 500;
    }

    .row-value {
      flex: 1;
      font-size: 15px;
      color: #333333;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}
</style>
